var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star",
    d: "M5.62 10.36L2.73 11.95C2.53 12.06 2.28 11.98 2.18 11.77C2.14 11.68 2.12 11.59 2.14 11.5L2.69 8.13C2.73 7.85 2.65 7.57 2.45 7.37L0.12 4.99C-0.04 4.82 -0.05 4.55 0.11 4.38C0.17 4.31 0.25 4.27 0.34 4.26L3.57 3.77C3.84 3.72 4.07 3.55 4.19 3.3L5.63 0.23C5.73 0.02 5.97 -0.07 6.17 0.04C6.26 0.08 6.32 0.15 6.36 0.23L7.8 3.3C7.92 3.55 8.15 3.72 8.42 3.77L11.65 4.26C11.87 4.29 12.02 4.51 11.99 4.74C11.98 4.83 11.94 4.92 11.87 4.99L9.54 7.37C9.34 7.57 9.26 7.85 9.3 8.13L9.85 11.5C9.89 11.73 9.74 11.95 9.52 11.99C9.43 12 9.34 11.99 9.26 11.95L6.37 10.36C6.14 10.22 5.85 10.22 5.62 10.36L5.62 10.36Z",
    fill: "#FFD925",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/fullStar.56cbf960d0bbea6851ff59fe851a66ec.svg";
export { ForwardRef as ReactComponent };